import React from "react";

const Loading = ({ msg }) => {
  return <div className="text-center">{msg || "Loading..."}</div>;
};

export default Loading;
